import React from 'react';
const painPoints = [{
  icon: '😴',
  title: 'Semanas sin dormir',
  description: 'Llevas meses durmiendo en bloques de 2 horas. El agotamiento está afectando tu trabajo, tu relación y tu salud mental.'
}, {
  icon: '😰',
  title: 'Ansiedad por el desarrollo',
  description: '¿Están alcanzando sus hitos? ¿Deberían estar haciendo esto ya? La comparación constante te consume todos los días.'
}, {
  icon: '📱',
  title: 'Información contradictoria',
  description: 'Buscas en Google a las 3 AM y cada resultado dice algo diferente. Más información, más confusión.'
}, {
  icon: '💸',
  title: 'Gastos interminables',
  description: 'Juguetes que no usan, dispositivos que prometían milagros y libros que nunca terminaste de leer.'
}];
export function PainSection() {
  return <section className="bg-white py-20 px-5" data-id="element-296">
      <div className="max-w-[900px] mx-auto" data-id="element-297">
        {/* Section header */}
        <div className="text-center mb-14" data-id="element-298">
          <span className="inline-block bg-red-50 text-red-400 text-xs font-sans font-bold tracking-[2.5px] uppercase py-[7px] px-[18px] rounded-full mb-5" data-id="element-299">
            ⚠️ ¿Te suena familiar?
          </span>
          <h2 className="text-[clamp(28px,4vw,42px)] text-[#2c1810] leading-[1.25] font-bold font-serif" data-id="element-300">
            El primer año es hermoso…
            <br data-id="element-301" />
            <span className="text-[#B76E79] italic font-normal" data-id="element-302">
              pero nadie te dijo lo difícil que sería.
            </span>
          </h2>
        </div>

        {/* Pain points grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-303">
          {painPoints.map((point, idx) => <div key={idx} className="bg-[#faf7f4] border border-[#ede5df] rounded-2xl p-7 flex flex-col gap-3 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-shadow" data-id="element-304">
              <span className="text-3xl" data-id="element-305">{point.icon}</span>
              <h3 className="text-lg font-bold text-[#2c1810] font-sans m-0" data-id="element-306">
                {point.title}
              </h3>
              <p className="text-[15px] leading-[1.75] text-[#5a4a42] font-sans m-0" data-id="element-307">
                {point.description}
              </p>
            </div>)}
        </div>

        {/* Bottom emotional line */}
        <p className="text-center mt-12 text-lg text-[#7a5a50] italic font-serif leading-relaxed max-w-[650px] mx-auto" data-id="element-308">
          No necesitas más consejos de extraños en internet. Necesitas{' '}
          <strong className="text-[#2c1810]" data-id="element-309">un sistema completo</strong>{' '}
          construido específicamente para los primeros 365 días — para que
          puedas dejar de sobrevivir y comenzar a estar plenamente presente para
          tu bebé.
        </p>
      </div>
    </section>;
}